import { Component, inject, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReportsModalComponent } from './reports-modal/reports-modal.component';
import { ReportService } from '../services/report.service';
import { Plant } from '../models/plant';
import { MatTableDataSource } from '@angular/material/table';
import { ReportEntry } from '../models/report';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  standalone: false,
})
export class ReportsComponent {
  private reportService = inject(ReportService);
  private route = inject(ActivatedRoute);
  public activeSection: string = 'reports';

  displayedColumns: string[] = ['status', 'equipment', 'equipmentType', 'reportAnalyses'];
  dataSource!: MatTableDataSource<ReportEntry>;

  //endpoint for plants
  public plants: Plant[] = [];
  public months: string[] = [];
  public selectedPlantId: string | null = null;
  public selectedMonth: string | null = null;

  // Mobile panel properties
  public isMobileView: boolean = false;
  public selectedEntry: ReportEntry | null = null;
  public isDetailPanelOpen: boolean = false;
  public isLoading: boolean = false;


  constructor(private dialog: MatDialog) {
    this.checkMobileView();
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      const activeSectionParm = params.get('activeSection');
      this.activeSection = activeSectionParm || 'reports';
    });
    this.reportService.getPlants().subscribe({
      next: (plants: Plant[]) => {
        this.plants = plants;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  public onPlantChange(plantId: string) {
    this.reportService.getMonths(plantId).subscribe({
      next: (months: string[]) => {
        this.months = months;
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  public openReport(entry: ReportEntry) {
    if (this.isMobileView) {
      this.selectedEntry = entry;
      this.isDetailPanelOpen = true;
    } else {
      this.dialog.open(ReportsModalComponent, {
        data: entry,
        width: '720px',
      });
    }
  }

  public closeDetailPanel() {
    this.isDetailPanelOpen = false;
    this.selectedEntry = null;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkMobileView();
  }

  private checkMobileView() {
    this.isMobileView = window.innerWidth <= 768;
  }

  public getMonthDateRange(month: string): string {
    if (!month) return '';

    // Parse the month string (format: "August 2025" or similar)
    const parts = month.split(' ');
    if (parts.length !== 2) return month;

    const monthName = parts[0];
    const year = parts[1];

    // Convert month name to number
    const monthIndex = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
    const monthStr = String(monthIndex).padStart(2, '0');
    const yearStr = year;

    // Get the last day of the month
    const lastDay = new Date(parseInt(year), monthIndex, 0).getDate();

    const startDate = `${yearStr}-${monthStr}-01`;
    const endDate = `${yearStr}-${monthStr}-${lastDay}`;

    return `${month} (${startDate} to ${endDate})`;
  }

  public searchReports() {
    if (!this.selectedPlantId || !this.selectedMonth) {
      console.warn('Please select both plant and month');
      return;
    }

    this.isLoading = true;
    this.reportService.getReportsAnalyses(this.selectedPlantId, this.selectedMonth).subscribe({
      next: (data) => {
        this.dataSource = new MatTableDataSource(data);
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Error fetching reports:', error);
        this.isLoading = false;
      }
    });
  }
    get allModesOk(): boolean {
    return this.selectedEntry!.reportAnalyses!.every(ra => ra.status === 'ok');
  }
}
